import { createContext } from "react";

export const InvitationModalContext = createContext();
